import { HTTP } from '@/http/http-client';

const getLocations = () =>
    HTTP.get(`no-auth/schools/slug/settings/locations/parents`).then(({ data }) => data);

export default {
    getLocations
};


// WEBPACK FOOTER //
// ./src/http/services/pageOptionsService.js